import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TableroTurnosComponent } from './tablero-turnos.component';
import { TableroTurnosRouting } from './tablero-turnos-routing.module';


@NgModule({
    declarations: [
        TableroTurnosComponent
    ],
    imports: [
        TableroTurnosRouting,
        SharedModule,
        CommonModule
    ],
    entryComponents: []
})

export class TableroTurnosModule { }
